<template>
  <div class="color-picker" @click.stop>
    <div class="color-picker__button" :class="state.active ? 'active' : ''" @click.stop="toggleTooltip">
      <svg width="34" height="33" viewBox="0 0 34 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.51768 26.3239L6.16881 27.6311L4.92644 26.3492L6.27531 25.0419L6.63138 24.6969L6.57223 24.2045L6.2532 21.5493L17.5809 10.5713L22.3356 15.4774L11.0079 26.4554L8.36397 26.0533L7.87376 25.9788L7.51768 26.3239Z" stroke="currentColor" stroke-width="2"/>
        <path d="M7.51795 26.3244L6.16907 27.6316L4.9267 26.3497L6.27557 25.0424L6.63165 24.6973L6.57249 24.205L6.25346 21.5498L7.21241 20.6204L14.8985 22.6857L11.0082 26.4559L8.36424 26.0538L7.87402 25.9793L7.51795 26.3244Z" fill="currentColor" stroke="currentColor" stroke-width="2"/>
        <rect x="15.8469" y="7.34473" width="13.879" height="1.91892" rx="0.959461" transform="rotate(45.898 15.8469 7.34473)" fill="currentColor"/>
        <path d="M23.0054 5.31337C24.1952 4.16031 26.0945 4.19008 27.2475 5.37987L27.8266 5.97739C28.9797 7.16718 28.9499 9.06644 27.7601 10.2195L23.0827 14.7525L18.328 9.84639L23.0054 5.31337Z" stroke="currentColor" stroke-width="2"/>
      </svg>
    </div>
    <transition name="fade">
      <div class="color-picker__tooltip" v-if="state.active">
        <div class="color-picker__item blue" @click.stop="setColor('blue')">
          <svg v-if="state.color === 'blue'" class="color-picker__item-icon" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 6.35714L6.54658 11L14 1" stroke="currentColor" stroke-width="3"/>
          </svg>
        </div>
        <div class="color-picker__item orange" @click.stop="setColor('orange')">
          <svg v-if="state.color === 'orange'" class="color-picker__item-icon" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 6.35714L6.54658 11L14 1" stroke="currentColor" stroke-width="3"/>
          </svg>
        </div>
        <div class="color-picker__item pink" @click.stop="setColor('pink')">
          <svg v-if="state.color === 'pink'" class="color-picker__item-icon" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 6.35714L6.54658 11L14 1" stroke="currentColor" stroke-width="3"/>
          </svg>
        </div>
        <div class="color-picker__item green" @click.stop="setColor('green')">
          <svg v-if="state.color === 'green'" class="color-picker__item-icon" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 6.35714L6.54658 11L14 1" stroke="currentColor" stroke-width="3"/>
          </svg>
        </div>
        <div class="color-picker__item purple" @click.stop="setColor('purple')">
          <svg v-if="state.color === 'purple'" class="color-picker__item-icon" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 6.35714L6.54658 11L14 1" stroke="currentColor" stroke-width="3"/>
          </svg>
        </div>
        <div class="color-picker__item violet" @click.stop="setColor('violet')">
          <svg v-if="state.color === 'violet'" class="color-picker__item-icon" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 6.35714L6.54658 11L14 1" stroke="currentColor" stroke-width="3"/>
          </svg>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app-column-color-picker',
  props: {
    state: Object
  },
  methods: {
    toggleTooltip () {
      this.$emit('toggle-tooltip')
    },
    setColor (colorName) {
      this.$emit('set-color', colorName)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.color-picker {
  position: relative;

  &__button {
    color: $font_color_alt;
    transition: .3s;

    &:hover {
      opacity: .5;
    }

    &.active {
      opacity: .5;
    }
  }

  &__tooltip {
    position: absolute;
    top: calc(100% + 15px);
    left: auto;
    right: 0;
    display: flex;
    flex-flow: row wrap;
    width: 162px;
    background-color: $color_main;
    border: 1px solid $border_color;
    border-radius: 3px;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    padding: 16px 12px 12px 16px;
    cursor: auto;

    &:before {
      content: '';
      display: block;
      position: absolute;
      top: -6px;
      left: auto;
      right: 14px;
      width: 10px;
      height: 10px;
      background: linear-gradient(-45deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 50%, $color_main 50%, $color_main 100%);
      border: 1px solid $border_color;
      border-bottom: none;
      border-right: none;
      transform: rotate(45deg);
    }
  }

  &__item {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    @include size(40px);
    border-radius: 3px;
    margin-right: 4px;
    margin-bottom: 4px;
    cursor: pointer;

    &-icon {
      color: $color_main;
    }

    &.blue {
      background: #2278BA;
      background: linear-gradient(90deg, #6672B1 0%, #2278BA 100%);
    }

    &.orange {
      background: #F86758;
      background: linear-gradient(95.94deg, #FAA658 -20.08%, #F86758 122.58%);
    }

    &.pink {
      background: #D75798;
      background: linear-gradient(102.64deg, #E8506F 9.26%, #D75798 100%);
    }

    &.green {
      background: #83BC70;
      background: linear-gradient(90deg, #559E97 -18.5%, #83BC70 119.25%);
    }

    &.purple {
      background: #790D7F;
      background: linear-gradient(90deg, #BC1183 -18.5%, #790D7F 119.25%);
    }

    &.violet {
      background: #143568;
      background: linear-gradient(90deg, #6E34B8 -18.5%, #143568 119.25%);
    }
  }
}
</style>
